export const getAllMessages = (state) => state.messages;

export const hasFatalError = (state) => Boolean(state.current?.fatalError);

